import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { PhoneInputRefType } from 'react-international-phone/build/components/PhoneInput/PhoneInput'
import { useDispatch, useSelector } from 'react-redux'

import { parsePhoneNumber } from 'awesome-phonenumber'

import { setMultipleAnswerAction } from 'root-redux/actions/common'
import { sendUserAnswersAction } from 'root-redux/actions/user'
import { selectUserCountryCode } from 'root-redux/selects/user'

import { TPageProps } from 'models/common.model'

import { eventLogger } from 'services/eventLogger.service'

import gpsIcon from 'assets/images/gps-icon.svg'

import { goTo } from 'browser-history'
import { CustomPageId } from 'root-constants/pages'

import { StyledPhoneNumberVariant4 as S } from './PhoneNumberVariant4.styles'
import { SECURE_DATA } from './constants'

export const PhoneNumberVariant4: React.FC<TPageProps> = ({ nextPagePath }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const inputRef = useRef<PhoneInputRefType>(null)
  const [phoneNumber, setPhoneNumber] = useState('')
  const countryCode = useSelector(selectUserCountryCode)
  const [isBlurred, setIsBlurred] = useState(false)
  const [userPhoneCountry, setUserPhoneCountry] = useState('')
  const isValid = parsePhoneNumber(phoneNumber).valid

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus()
    }
  }, [])

  const handleChange = (value: string, { country }) => {
    setPhoneNumber(value)
    setUserPhoneCountry(country.name)
  }

  const handleBlur = () => {
    setIsBlurred(true)
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    dispatch(
      setMultipleAnswerAction({
        answers: {
          [CustomPageId.PHONE_NUMBER]: phoneNumber,
          userPhoneCountry,
        },
      }),
    )
    dispatch(sendUserAnswersAction())
    eventLogger.logCheckNumberClicked()
    goTo(nextPagePath)
  }

  return (
    <S.Wrapper>
      <S.Column>
        <S.TitleWrapper>
          <p>{t`onboarding.intro8.subtitle`}</p>
          <S.SecureWrapper>
            {SECURE_DATA.map(({ img, text }) => (
              <S.SecureContainer key={text}>
                <img src={img} alt="icon" />
                {t(text)}
              </S.SecureContainer>
            ))}
          </S.SecureWrapper>
        </S.TitleWrapper>
        <S.PhoneForm onSubmit={handleSubmit}>
          <S.PhoneNumberInput
            defaultCountry={countryCode.toLowerCase()}
            value={phoneNumber}
            onChange={handleChange}
            onBlur={handleBlur}
            ref={inputRef}
          />
          {isBlurred && !isValid && (
            <S.PhoneErrorText>
              {t`onboarding.introGoogle3.phoneError`}
            </S.PhoneErrorText>
          )}
          <S.Button type="submit" disabled={!isValid}>
            <img src={gpsIcon} alt="icon" />
            {t`onboarding.introGoogle4.phoneButton`}
          </S.Button>
        </S.PhoneForm>
      </S.Column>
    </S.Wrapper>
  )
}
